<div style="padding: 20px 15px">
  <div fxLayout="row" fxLayoutAlign="space-between start">
    <h3>Associate Materials</h3>
    <div
      fxLayout="row"
      fxLayoutAlign="start"
      fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
    >
      <button
        mat-stroked-button
        color="primary"
        (click)="onCancelAssociateMaterials()"
      >
        Cancel
      </button>
      <button
        [disabled]="!canSaveAssociateMaterials"
        (click)="onSaveAssociateMaterials()"
        mat-raised-button
        color="primary"
      >
        Save
      </button>
    </div>
  </div>
  <p>
    Where applicable, please ensure that the previously filed materials you are
    associating are filed and stamped. Supporting material such as case law or
    legislation is not required to be stamped. Once material is associated to a
    hearing, it cannot be removed. Please do not associate any confidential material.
  </p>
  <div>
    <mat-tab-group
      animationDuration="0ms"
      [selectedIndex]="selectedTabIndex"
      (selectedTabChange)="onTabChanged($event)"
    >
      <mat-tab label="Pull from system">
        <div style="margin-top: 20px">
          <jsg-hearing-associate-materials-system-view
            [tableData]="actionFilesFromSystem"
            [form]="fromSystemMaterialsForm"
            (selectUploadTab)="onSelectUploadTab()"
            (openFile)="onOpenFile($event)"
          >
          </jsg-hearing-associate-materials-system-view>
        </div>
      </mat-tab>
      <mat-tab label="Upload from desktop">
        <div style="margin-top: 20px">
          <jsg-hearing-associate-materials-upload-view
            [tableData]="associateMaterialsUploads"
            [associateMaterialsUploadInfoText]="
              associateMaterialsUploadInfoText
            "
            [associateMaterialTypeGroup]="associateMaterialTypeGroup"
            [form]="associateDocumentUploadForm"
            (filesSelected)="onFilesSelected($event)"
            (cancelUpload)="onCancelUploadClick($event)"
            (deleteUpload)="onDeleteUploadClick($event)"
            (openFile)="onOpenFile($event)"
          >
          </jsg-hearing-associate-materials-upload-view>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
